import { memo } from "react";

import type { RequestFilterType } from "../../../types/filters";

import { pausedTableConfig } from "../../../config/tables/superadmin/pausedTableConfig";
import { UnifiedSuperAdminTab } from "./UnifiedSuperAdminTab";

interface PausedTabProps {
  lazyLoadingConfig?: {
    currentTab: string;
    enabled: boolean;
  };
  searchValue?: string;
  selectedFilter?: RequestFilterType;
}

function PausedTabComponent(props: PausedTabProps) {
  return (
    <UnifiedSuperAdminTab
      {...props}
      tableConfig={pausedTableConfig}
      tabType="paused"
    />
  );
}

export const PausedTab = memo(PausedTabComponent);
